const extractFilename = (contentDisposition?: string | null): string | undefined => {
  if (!contentDisposition) {
    return undefined;
  }

  const match = contentDisposition
    .split(';')
    .map((parameter) => parameter.trim())
    .find((parameter) => /^filename\*?=/i.test(parameter));

  if (!match) {
    return undefined;
  }

  const [, value = ''] = match.split('=');

  if (/^filename\*/i.test(match)) {
    const decoded = value.replace(/^UTF-8''/i, '').replace(/^["']|["']$/g, '');
    try {
      return decodeURIComponent(decoded);
    } catch {
      return decoded;
    }
  }

  return value.replace(/^["']|["']$/g, '');
};

const triggerCsvDownload = (blob: Blob, contentDisposition?: string | null) => {
  if (typeof document === 'undefined') {
    return;
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  const fileName = extractFilename(contentDisposition ?? undefined) ?? 'products-export.csv';

  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

function asDate(date?: string | Date | null): Date | null {
  if (!date) return null;
  if (date instanceof Date) return date;
  return new Date(date);
}

export { extractFilename, triggerCsvDownload, asDate };
